{
  "confirmInvalidateDescription": "Otras granjas ya no podrán usar este código para agregar este dispositivo a su cuenta",
  "createDeviceShareCodeInstructions": "Establecer permisos para las granjas que utilizarán este dispositivo.",
  "createDeviceShareCodeSuccessMessage": "Su código para compartir ha sido creado exitosamente.",
  "currentDeviceShareCode": "Código actual",
  "deviceOwnership": "Propiedad del dispositivo",
  "deviceOwnershipLinkTo": "Propiedad",
  "farmsBorrowingDeviceListEmpty": "Actualmente ninguna granja está tomando prestado este dispositivo.",
  "helpContent": "Los dispositivos se pueden compartir con otras granjas mediante un código de uso compartido de dispositivos. Puede otorgar acceso a usuarios fuera de su granja y especificarles permisos específicos mientras usan el dispositivo.",
  "invalidateButton": "Invalidar",
  "newDeviceShareCode": "Nuevo código para compartir dispositivos",
  "primaryOwnerLabel": "Propietario principal",
  "requestDeviceRemovalButton": "Quitar dispositivo",
  "requestDeviceRemovalDescription": "El dispositivo se eliminará de esta cuenta de granja.",
  "requestDeviceRemovalInstructions": "Para continuar, escriba el alias del dispositivo.",
  "requestDeviceRemovalNote": "Nota: Esta acción no afectará la facturación.",
  "requestDeviceRemovalTitle": "Solicitar la eliminación del dispositivo",
  "requestRemovalALiasMustMatchErrorMessageWithCodaDeviceAlias": "El alias debe coincidir exactamente con {{codaDeviceAlias}}.",
  "shareDeviceShareCodeMessagePrefixWithCodeStrAndDeviceName": "Ingrese este código para obtener acceso al dispositivo FarmHQ {{deviceName}}: {{codeStr}}",
  "shareTitlePrefixWithFarmName": "[FarmHQ]: Código de uso compartido del dispositivo de {{farmName}}"
}
